import React, {useRef, useState} from "react";
import {TranscriptRoutingDecisionUi} from "../../../../../api/generated";
import styles from "./RoutingDetails.module.css";

interface Props {
    routingDecision: TranscriptRoutingDecisionUi;
    collapsible?: boolean;
}

export const RoutingDetails: React.FC<Props> = ({routingDecision, collapsible = false}) => {
    const [expanded, setExpanded] = useState(!collapsible);
    const collapseRef = useRef<HTMLDivElement>(null);

    // Kept mounted so collapsing animates the same way expanding does.
    const collapseMaxHeight = !collapsible
        ? "none"
        : expanded ? `${collapseRef.current?.scrollHeight ?? 0}px` : 0;

    return (
        <div className={styles.wrapper}>
            {collapsible && (
                <button className={styles.toggle} onClick={() => setExpanded(prev => !prev)}>
                    {expanded ? "Hide routing details" : "View routing details"}
                </button>
            )}
            <div className={styles.collapse} ref={collapseRef} style={{maxHeight: collapseMaxHeight}}>
                <div className={styles.content}>
                    {routingDecision.leadIntentSummary && (
                        <div className={styles.section}>
                            <span className={styles.label}>Intent summary</span>
                            <p className={styles.summary}>{routingDecision.leadIntentSummary}</p>
                        </div>
                    )}
                    {routingDecision.departmentSelections && routingDecision.departmentSelections.length > 0 && (
                        <div className={styles.section}>
                            <span className={styles.label}>Selected departments</span>
                            <table className={styles.table}>
                                <thead>
                                <tr>
                                    <th>Department ID</th>
                                    <th>Source</th>
                                    <th>Score</th>
                                    <th>Reason</th>
                                </tr>
                                </thead>
                                <tbody>
                                {routingDecision.departmentSelections.map((sel, idx) => (
                                    <tr key={idx}>
                                        <td>{sel.departmentId}</td>
                                        <td>
                                            <span className={sel.source === "LLM" ? styles.badgeLlm : styles.badgeKeyEvent}>
                                                {sel.source}
                                            </span>
                                        </td>
                                        <td>{sel.score != null ? `${Math.round(sel.score * 100)}%` : "—"}</td>
                                        <td>{sel.reason ?? "—"}</td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};
